import React from "react";
import ReactDOM from "react-dom";
import "react-dates/initialize";
import * as Sentry from "@sentry/browser";
import "./index.css";
import "react-dates/lib/css/_datepicker.css";

import App from "./App";
import { unregister } from "./registerServiceWorker";
import { reportOauthPopupResult } from "@hooks/useOauthPopup";

Sentry.init({
  dsn: "https://0166dbb024ca42fb9ec4af1e0c046b49@sentry.io/1413893",
  environment: process.env.REACT_APP_ENV,
});

const render = (Component) =>
  ReactDOM.render(<Component />, document.getElementById("root"));

// "Connect account" OAuth flows run in a popup window (see hooks/useOauthPopup).
// When this page load *is* that popup coming back from the provider, hand the
// result to the tab that opened it and close, instead of booting the app.
if (reportOauthPopupResult()) {
  document.getElementById("root").innerHTML =
    '<p style="font-family: sans-serif; padding: 24px; color: #4b5c6b;">Finishing up… you can close this window.</p>';
} else {
  render(App);
}

// registerServiceWorker(); DISABLE SERVICE WORKERS
unregister(); // unregister any existing service workers

if (module.hot) {
  module.hot.accept("./App", () => render(require("./App").default));
}
